/**
 * Ikki til: o'zbekcha va ruscha.
 *
 * Qoida: kod ichida matn emas, **kalit** yuriydi. Zod sxemalari, servislar
 * va `AppError` xabar o'rniga kalit beradi; matn oxirgi nuqtada — javob
 * yig'ilayotganda yoki ekranga chiqishdan oldin — tanlanadi.
 *
 * Shu sababli bitta xabar ikki joyda (backend va frontend) takrorlanmaydi:
 * lug'at bitta va u shu paketda.
 */
export const LANGS = ['uz', 'ru'];
export const DEFAULT_LANG = 'uz';
/**
 * `Accept-Language` sarlavhasidan tilni aniqlaydi.
 * Ruscha aniq so'ralmasa — o'zbekcha.
 */
export function parseLang(header) {
    if (!header)
        return DEFAULT_LANG;
    const first = header.split(',')[0]?.trim().toLowerCase() ?? '';
    return first.startsWith('ru') ? 'ru' : DEFAULT_LANG;
}
/* ── Lug'at ────────────────────────────────────────────────────────────── */
const uz = {
    // Validatsiya (zod sxemalari shu kalitlarni beradi)
    'v.required': 'Maydon to\'ldirilishi shart',
    'v.invalid': "Qiymat noto'g'ri",
    'v.phone': "Telefon raqami 998XXXXXXXXX ko'rinishida bo'lishi kerak",
    'v.pinfl': "JSHSHIR 14 ta raqamdan iborat bo'lishi kerak",
    'v.passport': "Pasport AA1234567 ko'rinishida bo'lishi kerak",
    'v.panChecksum': "Karta raqamida xatolik bor — qaytadan tekshiring",
    'v.pan': "Karta raqami 16 ta raqamdan iborat bo'lishi kerak",
    'v.cardExpiry': "Amal muddati 4 ta raqamdan iborat bo'lishi kerak",
    'v.ikpu': "IKPU 17 ta raqamdan iborat bo'lishi kerak",
    'v.amountInt': "Summa tiyinda, butun son bo'lishi kerak",
    'v.amountPositive': "Summa noldan katta bo'lishi kerak",
    'v.isoDate': "Sana YYYY-MM-DD ko'rinishida bo'lishi kerak",
    'v.password': "Parol kamida 6 belgidan iborat bo'lishi kerak",
    'v.passwordWeak': "Yangi parol kamida 8 belgidan iborat bo'lishi kerak",
    'e.userPhoneTaken': "Bu raqam bilan foydalanuvchi allaqachon bor",
    'e.sellerNotAtAlif': "Bu sotuvchi Alifda ro'yxatdan o'tmagan — uning nomidan yuborib bo'lmaydi",
    'e.storeNameTaken': "Bu nomdagi do'kon allaqachon bor",
    'r.alifNoCard': "Mijozning kartasi Alifda ishlamadi — boshqa karta bilan urinib ko'ring",
    'r.alifBlocked': 'Mijoz Alifda bloklangan',
    'r.uzumOtherPhone': "Mijoz Uzumda boshqa raqam bilan ro'yxatdan o'tgan — o'sha raqamni kiriting",
    'r.alifCardWait': "Alif kod yuborish uchun bir daqiqa kutishni so'radi — biroz kutib, qayta yuboring",
    'e.userSelfDisable': "O'zingizni o'chirib qo'ya olmaysiz",
    'e.userLastAdmin': "Oxirgi ma'murni o'chirib bo'lmaydi — tizim boshqaruvsiz qoladi",
    'e.passwordWrong': "Joriy parol noto'g'ri",
    'v.passwordLong': "Parol juda uzun (72 belgidan ko'p emas)",
    'v.otpCode': "Kod 6 ta raqamdan iborat bo'lishi kerak",
    'v.contractOtpCode': "OTP kodi 4–6 raqamdan iborat bo'lishi kerak",
    'v.contactName': "Ism kamida 2 ta belgidan iborat bo'lishi kerak",
    'v.contactsMin': "Kamida 2 ta qo'shimcha kontakt kiritilishi kerak",
    'v.contactsCloseRelative': "Kamida bitta kontakt yaqin qarindosh bo'lishi kerak",
    'v.contactsDuplicate': 'Kontakt raqamlari takrorlanmasligi kerak',
    'v.contactsOwnPhone': "Kontakt raqami mijozning o'z raqami bilan bir xil bo'lmasligi kerak",
    'v.identityRequired': "JSHSHIR yoki pasport ma'lumotlaridan biri kiritilishi shart",
    'v.phoneNotVerified': 'Telefon raqami tasdiqlanmagan yoki muddati tugagan',
    'v.photoFormat': 'Rasm formati notanish',
    'v.itemName': 'Tovar nomi majburiy',
    'v.quantity': "Miqdor musbat butun son bo'lishi kerak",
    'v.duration': "Muddat musbat butun son bo'lishi kerak",
    'v.itemsMin': 'Kamida bitta tovar kiritilishi kerak',
    'v.amountMismatch': "Umumiy summa tovarlar yig'indisiga teng emas",
    'v.conditionUnknown': 'Tanlangan shart provayder taklifida yo\'q',
    // Provayder rad etish sabablari (mock stsenariylari va orchestrator)
    'r.noCreditHistory': 'Kredit tarixi yetarli emas',
    'r.overdueDebt': "Faol muddati o'tgan qarz mavjud",
    'r.lowSolvency': "To'lov qobiliyati past",
    'r.lowScore': 'Skoring balli past',
    'r.rejected': 'Rad etildi',
    'r.providerTimeout': 'Provayder belgilangan vaqtda javob bermadi',
    'r.providerError': 'Provayder xizmatida texnik nosozlik',
    'r.otpNotConfirmed': 'Karta tasdiqlanmadi: SMS kod kiritilmadi',
    'r.uzumBlacklist': "Uzum ro'yxatida cheklov bor",
    'r.uzumNoLimit': 'Uzumda hozircha limit yo\'q',
    'r.uzumManualScoring': "Ma'lumotlar Uzumga yuborildi. Limit qo'lda belgilanadi — javobni kuting",
    'r.uzumNeedsRealMyid': "Mijoz Uzumda ro'yxatdan o'tmagan. Ro'yxatdan o'tkazish uchun haqiqiy MyID kerak (hozir sinov rejimi)",
    // Servis xabarlari
    'e.loginTooMany': "Juda ko'p urinish. 15 daqiqadan so'ng qayta urinib ko'ring.",
    'e.otpTooMany': "Bu raqamga juda ko'p kod yuborildi. Birozdan so'ng urinib ko'ring.",
    'e.otpCooldown': "Kod hozirgina yuborildi. {seconds} soniyadan so'ng qayta urinib ko'ring.",
    'e.myidDailyLimit': "Bugungi identifikatsiyalar chegarasi tugadi. Administratorga murojaat qiling.",
    'e.otpResendLimit': "Kodni qayta yuborish chegarasi tugadi. Scoringni qaytadan boshlang.",
    'e.otpResendFailed': 'Provayder kodni qayta yubora olmadi',
    'e.scoringNoOtp': 'Bu provayder hozir kod kutmayapti',
    'e.contractNoProvider': 'Avval provayder tanlanishi kerak',
    'e.contractExists': 'Bu scoring bo\'yicha ariza allaqachon rasmiylashtirilgan',
    'e.contractProviderFailed': 'Provayder arizani qabul qilmadi',
    'e.myidNoProfile': "MyID profil ma'lumotlarini qaytarmadi",
    'e.myidNoPhoto': 'MyID rasmni qaytarmadi — provayderlarga yuborib bo\'lmaydi',
    'e.myidPhotoBlocked': "Identifikatsiya o'tdi, lekin MyID rasmni bermadi (kirish yopiq). Ma'lumotlar saqlandi — kirish ochilgach rasm o'zi olinadi.",
    'e.myidTimeout': 'MyID belgilangan vaqtda javob bermadi',
    'e.myidNoPinfl': "MyID profilida JSHSHIR yo'q",
    'e.myidNoToken': 'MyID token bermadi',
    'e.myidRejected': "MyID ASKO ulanishini rad etdi — identifikatsiya hozircha ishlamaydi. Administratorga xabar bering.",
    'e.myidUnavailable': "MyID hozir javob bermayapti. Birozdan so'ng qayta urinib ko'ring.",
    'e.myidCodeUsed': "Havola allaqachon ishlatilgan yoki muddati tugagan — sotuvchidan yangi QR so'rang",
    'e.myidNoSession': 'MyID sessiya yaratmadi',
    'e.myidNoJob': 'MyID vazifa yaratmadi',
    'e.myidPhotoRejected': 'MyID rasmni qabul qilmadi',
    'e.myidPhotoTimeout': 'MyID rasm yuklashda javob bermadi',
    'e.myidPhotoUpload': "Rasmni yuborib bo'lmadi",
    'e.smsNoToken': 'Eskiz token bermadi',
    'e.photoFormat': "Rasm formati png yoki jpeg bo'lishi kerak",
    'e.photoTooLarge': 'Rasm hajmi 1.5 MB dan oshmasligi kerak',
    'e.photoTooSmall': 'Rasm hajmi juda kichik (300 KB dan kam)',
    'e.notConfigured': '{provider} integratsiyasi sozlanmagan: kalitlar kiritilmagan',
    'e.notImplemented': 'Hali tayyor emas: {what}',
    'e.networkDown': "Serverga ulanib bo'lmadi. Internet aloqasini tekshiring.",
};
const ru = {
    'v.required': 'Поле обязательно для заполнения',
    'v.invalid': 'Неверное значение',
    'v.phone': 'Номер телефона должен быть в формате 998XXXXXXXXX',
    'v.pinfl': 'ПИНФЛ должен состоять из 14 цифр',
    'v.passport': 'Паспорт должен быть в формате AA1234567',
    'v.pan': 'Номер карты должен состоять из 16 цифр',
    'v.panChecksum': 'В номере карты ошибка — проверьте ещё раз',
    'v.cardExpiry': 'Срок действия должен состоять из 4 цифр',
    'v.ikpu': 'ИКПУ должен состоять из 17 цифр',
    'v.amountInt': 'Сумма указывается в тийинах, целым числом',
    'v.amountPositive': 'Сумма должна быть больше нуля',
    'v.isoDate': 'Дата должна быть в формате ГГГГ-ММ-ДД',
    'v.password': 'Пароль должен быть не короче 6 символов',
    'v.passwordWeak': 'Новый пароль должен быть не короче 8 символов',
    'e.userPhoneTaken': 'Пользователь с таким номером уже есть',
    'e.sellerNotAtAlif': 'Этот продавец не зарегистрирован в Alif — от его имени отправить нельзя',
    'e.storeNameTaken': 'Магазин с таким названием уже есть',
    'r.alifNoCard': 'Карта клиента не принята Alif — попробуйте другую карту',
    'r.alifBlocked': 'Клиент заблокирован в Alif',
    'r.uzumOtherPhone': 'Клиент зарегистрирован в Uzum на другой номер — введите его',
    'r.alifCardWait': 'Alif просит подождать минуту перед повторной отправкой кода — подождите и отправьте скоринг заново',
    'e.userSelfDisable': 'Нельзя отключить самого себя',
    'e.userLastAdmin': 'Нельзя убрать последнего администратора — система останется без управления',
    'e.passwordWrong': 'Текущий пароль неверен',
    'v.passwordLong': 'Пароль слишком длинный (не больше 72 символов)',
    'v.otpCode': 'Код должен состоять из 6 цифр',
    'v.contractOtpCode': 'OTP-код должен состоять из 4–6 цифр',
    'v.contactName': 'Имя должно быть не короче 2 символов',
    'v.contactsMin': 'Нужно указать минимум 2 дополнительных контакта',
    'v.contactsCloseRelative': 'Хотя бы один контакт должен быть близким родственником',
    'v.contactsDuplicate': 'Номера контактов не должны повторяться',
    'v.contactsOwnPhone': 'Номер контакта не должен совпадать с номером клиента',
    'v.identityRequired': 'Нужно указать ПИНФЛ или паспортные данные',
    'v.phoneNotVerified': 'Номер телефона не подтверждён или срок подтверждения истёк',
    'v.photoFormat': 'Неизвестный формат изображения',
    'v.itemName': 'Название товара обязательно',
    'v.quantity': 'Количество должно быть целым положительным числом',
    'v.duration': 'Срок должен быть целым положительным числом',
    'v.itemsMin': 'Нужно добавить хотя бы один товар',
    'v.amountMismatch': 'Общая сумма не совпадает с суммой товаров',
    'v.conditionUnknown': 'Выбранный вариант отсутствует в предложении провайдера',
    'r.noCreditHistory': 'Недостаточная кредитная история',
    'r.overdueDebt': 'Есть активная просроченная задолженность',
    'r.lowSolvency': 'Низкая платёжеспособность',
    'r.lowScore': 'Низкий скоринговый балл',
    'r.rejected': 'Отказано',
    'r.providerTimeout': 'Провайдер не ответил за отведённое время',
    'r.providerError': 'Техническая неисправность на стороне провайдера',
    'r.otpNotConfirmed': 'Карта не подтверждена: SMS-код не введён',
    'r.uzumBlacklist': 'В Uzum по клиенту есть ограничение',
    'r.uzumNoLimit': 'В Uzum сейчас нет лимита',
    'r.uzumManualScoring': 'Данные переданы в Uzum. Лимит определяется вручную — ждите ответа',
    'r.uzumNeedsRealMyid': 'Клиента нет в Uzum. Для регистрации нужен настоящий MyID (сейчас тестовый режим)',
    'e.loginTooMany': 'Слишком много попыток. Повторите через 15 минут.',
    'e.otpTooMany': 'На этот номер отправлено слишком много кодов. Попробуйте позже.',
    'e.otpCooldown': 'Код только что отправлен. Повторите через {seconds} с.',
    'e.myidDailyLimit': 'Дневной лимит идентификаций исчерпан. Обратитесь к администратору.',
    'e.otpResendLimit': 'Лимит повторной отправки кода исчерпан. Начните скоринг заново.',
    'e.otpResendFailed': 'Провайдер не смог отправить код повторно',
    'e.scoringNoOtp': 'Этот провайдер сейчас не ждёт код',
    'e.contractNoProvider': 'Сначала нужно выбрать провайдера',
    'e.contractExists': 'Заявка по этому скорингу уже оформлена',
    'e.contractProviderFailed': 'Провайдер не принял заявку',
    'e.myidNoProfile': 'MyID не вернул данные профиля',
    'e.myidNoPhoto': 'MyID не вернул фото — провайдерам отправить нечего',
    'e.myidPhotoBlocked': 'Идентификация пройдена, но MyID не отдал фото (доступ закрыт). Данные сохранены — как только доступ откроют, фото подтянется само.',
    'e.myidTimeout': 'MyID не ответил за отведённое время',
    'e.myidNoPinfl': 'В профиле MyID нет ПИНФЛ',
    'e.myidNoToken': 'MyID не выдал токен',
    'e.myidRejected': 'MyID отклонил подключение ASKO — идентификация пока не работает. Сообщите администратору.',
    'e.myidUnavailable': 'MyID сейчас не отвечает. Попробуйте чуть позже.',
    'e.myidCodeUsed': 'Ссылка уже использована или устарела — попросите у продавца новый QR-код',
    'e.myidNoSession': 'MyID не создал сессию',
    'e.myidNoJob': 'MyID не создал задачу',
    'e.myidPhotoRejected': 'MyID не принял снимок',
    'e.myidPhotoTimeout': 'MyID не ответил при загрузке снимка',
    'e.myidPhotoUpload': 'Не удалось отправить снимок',
    'e.smsNoToken': 'Eskiz не выдал токен',
    'e.photoFormat': 'Формат изображения должен быть png или jpeg',
    'e.photoTooLarge': 'Размер изображения не должен превышать 1.5 МБ',
    'e.photoTooSmall': 'Размер изображения слишком мал (меньше 300 КБ)',
    'e.notConfigured': 'Интеграция {provider} не настроена: не заданы ключи',
    'e.notImplemented': 'Ещё не готово: {what}',
    'e.networkDown': 'Не удалось связаться с сервером. Проверьте интернет-соединение.',
};
export const MESSAGES = { uz, ru };
export function isMessageKey(value) {
    return Object.prototype.hasOwnProperty.call(uz, value);
}
/**
 * Kalitni matnga aylantiradi.
 *
 * Kalit tanilmasa — kirgan satr o'zi qaytadi. Shunda tarjimasi hali
 * qo'shilmagan xabar ham foydalanuvchiga yetib boradi, kalit ko'rinishida
 * emas.
 */
export function translate(keyOrText, lang = DEFAULT_LANG, vars) {
    const template = isMessageKey(keyOrText) ? MESSAGES[lang][keyOrText] : keyOrText;
    if (!vars)
        return template;
    return template.replace(/\{(\w+)\}/g, (match, name) => name in vars ? String(vars[name]) : match);
}
//# sourceMappingURL=i18n.js.map